export default ({
    state: {
        processing: false,
        error: null,
        currentFormHeader: ''
    },
    mutations: {
        SET_PROCESSING(state, payload) {
            state.processing = payload
        },
        SET_ERROR(state, payload) {
            state.error = payload;
        },
        CLEAN_ERROR(state) {
            state.error = null;
        },
        SET_FORM_HEADER(state, payload) {
            state.currentFormHeader = payload;
        },
    },
    actions: {
    },
    getters: {
        getProcessing: state => state.processing,
        getError: state => state.error,
        currentFormHeader: state => state.currentFormHeader,
    }
})